angular.module('gym.subscriptions', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.subscriptions', {
    controller: 'SubscriptionsCtrl',
    url: '^/subscriptions?gymId',
    templateUrl: function($stateParams) {
      return `/subscriptions.template?gymId=${$stateParams.gymId}`;
    }
  }).state('gym.subscriptionPlans', {
    controller: 'SubscriptionPlansCtrl',
    url: '^/subscription_plans?gymId&feature_not_available',
    templateUrl: function($stateParams) {
      return `/subscription_plans.template?gymId=${$stateParams.gymId}`;
    },
    resolve: {
      subscriptionPlans: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/subscription_plans?gymId=${$stateParams.gymId}`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }]
    }
  });
}]);
